// src/components/RedirectToDefaultLang.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const DEFAULT_LANG = "en";
const SUPPORTED = ["en", "fr", "ar", "de"];
const STORAGE_KEY = "site_lang";

function normalizeLang(candidate) {
  if (!candidate) return null;
  const s = String(candidate).trim().toLowerCase();
  if (SUPPORTED.includes(s)) return s;
  const short = s.split(/[-_]/)[0];
  return SUPPORTED.includes(short) ? short : null;
}

function getPreferredLang() {
  // 1) localStorage (user explicit choice)
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    const s = normalizeLang(stored);
    if (s) return s;
  } catch (e) {}

  // 2) browser language
  try {
    const nav = navigator?.language || navigator?.userLanguage || "";
    const s = normalizeLang(nav);
    if (s) return s;
  } catch (e) {}

  // 3) fallback
  return DEFAULT_LANG;
}

export default function RedirectToDefaultLang() {
  const navigate = useNavigate();

  useEffect(() => {
    const rawPath = window.location.pathname || "/";
    const lower = rawPath.toLowerCase();

    // if already prefixed with supported lang ("/en" or "/en/") -> do nothing
    for (const l of SUPPORTED) {
      if (lower === `/${l}` || lower.startsWith(`/${l}/`)) {
        return;
      }
    }

    // determine the language to use (user choice or browser)
    const lang = getPreferredLang() || DEFAULT_LANG;

    // preserve search and hash
    const search = window.location.search || "";
    const hash = window.location.hash || "";

    // build and normalize new path
    const newPath = `/${lang}${rawPath === "/" ? "/" : rawPath}`.replace(/\/{2,}/g, "/");
    const final = `${newPath}${search}${hash}`;

    // avoid infinite replace if already same (rare)
    if (final === window.location.pathname + (window.location.search || "") + (window.location.hash || "")) {
      return;
    }

    navigate(final, { replace: true });
  }, [navigate]);

  return null;
}
